<template>
    <div>
        <v-row no-gutters width="70vw">
            <v-col cols="12">
                        <h3 class="mb-5">Rango de Fechas</h3>
                        <p class="mb-5">Seleccione el rango de fechas en que quiere obtener la información</p>
            </v-col>
            <v-col cols="12" lg="6">
            <v-menu v-model="menu1" :close-on-content-click="false" max-width="290">
                <template v-slot:activator="{ on, attrs }">
                <v-text-field class="pa-1"
                    rounded
                    filled
                    :value="format_date_initial"
                    clearable
                    label="Fecha de inicio"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    @click:clear="clearInicio"
                ></v-text-field>
                </template>
                <v-date-picker v-model="date_initial" @change="selectType"  min="2008-01-01" :max="initial_max_date()" locale="es-CL"></v-date-picker>
            </v-menu>
            </v-col>
            <v-col cols="12" lg="6">
            <v-menu v-model="menu2" :close-on-content-click="false" max-width="290">
                <template v-slot:activator="{ on, attrs }">
                <v-text-field class="pa-1"
                    rounded
                    filled
                    :value="format_date_final"
                    clearable
                    label="Fecha de termino"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    @click:clear="clearTermino"
                ></v-text-field>
                </template>
                <v-date-picker v-model="date_final" @change="selectType"  :min="temino_min_date()" :max="new Date().toISOString()" locale="es-CL"></v-date-picker>
            </v-menu>
            </v-col>
        </v-row>
        <div class="row">
            <ExporterButton
                v-for="(button) in exportadores_disponibles"
                :key="button.url"
                :title="button.title"
                :description="generando(button.url) ? 'Generando archivo, se descargará al terminar...' : button.descripcion"
                :iconLeft="button.icon"
                :onClick="() => exportar(button)"
                :disabled="datesSelected() || generando(button.url)"
            />
            
        </div>
    </div>
  </template>
  
  <script>
  import ButtonPrimary from "@/components/forms/ButtonPrimary.vue";
  import ExporterButton from "@/components/forms/ExporterButton.vue";
  import moment from "moment";
  import { mapGetters } from "vuex";
  import { EXPORTADORES } from "@/helpers/exportadores";

  export default {
    components: {
        ButtonPrimary,
        ExporterButton
    },
    data: () => ({
        menu1: false,
        menu2: false,
        date_initial: null,
        date_final: null,


        exportadores_disponibles: EXPORTADORES,
    }),
  
    computed: {
        ...mapGetters("exportaciones", ["generando"]),

        format_date_initial() {
        return this.date_initial
            ? moment(this.date_initial).format("dddd, Do MMMM, YYYY")
            : "";
        },

        format_date_final() {
        return this.date_final
            ? moment(this.date_final).format("dddd, Do MMMM, YYYY")
            : "";
        },
    },
    methods: {
        // El seguimiento vive en el store para que la planilla se descargue
        // aunque se salga de esta vista.
        exportar(exportador) {
            this.$store.dispatch("exportaciones/exportar", {
                exportador,
                fechas: { fecha_inicio: this.date_initial, fecha_fin: this.date_final },
            });
        },

        clearInicio() {
            this.date_initial = null;
            this.selectType();
        },
        clearTermino() {
            this.date_final = null;
            this.selectType();
        },
        selectType() {
            this.menu1 = false;
            this.menu2 = false;
        },
        datesSelected() {
            return !(this.date_initial && this.date_final);
        },

        initial_max_date() {

            if (this.date_final) {
                return this.date_final;
            } else {
                return new Date().toISOString();
            }
        },

        temino_min_date() {
            if (this.date_initial) {
                return this.date_initial;
            } else {
                return "2008-01-01";
            }
        }
        
            
    },
  };
  </script>
  
  <style>
  </style>